import { render, staticRenderFns } from "./ProductGroupSave.vue?vue&type=template&id=28d60136&scoped=true&"
import script from "./ProductGroupSave.vue?vue&type=script&lang=js&"
export * from "./ProductGroupSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d60136",
  null
  
)

export default component.exports